import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk'; // ✅ correct way
import rootReducer from './reducers';

// Initial state
const initialState = {};

// Middleware array
const middleware = [thunk];

// Redux DevTools extension support
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Create the Redux store
const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(applyMiddleware(...middleware))
);

export default store;
